<template>
  <el-container class="order-back">
    <el-header class="header-style">
      <el-divider content-position="left">订单反馈内容分析</el-divider>
      <el-row>
        <el-col :span="6">
          <el-input
            v-model="searchArr.keyword"
            size="mini"
            clearable
            placeholder="关键词:反馈内容"
            @blur="getOrderFeedbackList"
            @clear="getOrderFeedbackList"
          >
          </el-input>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table :data="orderFeedback" size="medium" border style="width: 100%" v-cloak>
        <el-table-column label="关键词" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.reflect_content">
              <p v-html="highlightText(scope.row.reflect_content, searchArr.keyword)"></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单号" width="330">
          <template slot-scope="scope">
            <div v-if="scope.row.orders">
              <el-link
                type="primary"
                :underline="false"
                @click="handleOrderInfo(scope.row.order_id)"
                >{{ scope.row.orders.order_num }}</el-link
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="反馈时间" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.created_at">
              <el-tooltip :content="scope.row.created_at" placement="top">
                <span class="count-style">{{ scope.row.created_at }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="反馈人" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.executor">
                <span class="count-style">{{ scope.row.executor }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr mt-10"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="订单信息"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import OrderInfo from "common/OrderInfo";
export default {
  name: "OrderFeedback",
  components: {
    OrderInfo,
  },
  data() {
    return {
      searchArr: {
        keyword: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      orderFeedback: [],
      orderInfoVisible: false,
      orderInfoId: null,
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getOrderFeedbackList() {
      this.$axios
        .get(
          "/api/admin/tyc_order/order_feedback/index?page=" +
            this.pageOption.currentPage +
            "&page_size=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            // console.log(data);return;
            this.orderFeedback = data.data.list.data;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getOrderFeedbackList();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getOrderFeedbackList();
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    highlightText(text, search) {
      const regex = new RegExp(search, "gi");
      return text.replace(regex, `<span style="color: red;">${search}</span>`);
    },
  },
  mounted() {
    this.getOrderFeedbackList();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.highlight {
  color: red !important;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.order-back >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.order-back {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 20px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/tyc_order/OrderFeedback.vue